<template>
    <div class="card display-rubric">
        <header class="card-header" @click="toggleRubric">
            <div class="card-header-title" :class="rubric.inline ? '' : 'is-clickable'">
                <div class="media">
                    <div class="media-left">
                        <e-icon v-if="!rubric.inline" :icon="displayRubric ? 'angle-up' : 'angle-down'" />

                        <span>{{ translate('rubric') }}</span>
                    </div>
                </div>
            </div>
        </header>

        <div v-show="displayRubric" class="card-content">
            <div class="columns is-multiline content">
                <div v-for="(criteria, index) in criterias" :key="index" class="column is-12">
                    <h5>{{ criteria.title }}</h5>

                    <!--<div class="has-text-weight-bold">-->
                    <!--Points Possible: {{ criteria.max_value }}-->
                    <!--</div>-->

                    <display-content v-if="criteria.description" :content="criteria.description" class="m-b-md" />

                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                        <tbody>
                            <tr v-for="rating in criteria.criteria_ratings" :key="rating.id">
                                <td>{{ rating.label }}</td>
                                <td>{{ rating.description }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import has from 'lodash/has.js';

import { useI18n } from 'vue-i18n';

import DisplayContent from '@/components/editor/DisplayContent.vue';
import Rubric from '@/models/Rubric.js';

export default {
    name: 'DisplayRubric',

    components: { DisplayContent },

    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },

    props: {
        rubric: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        displayRubric: false,
    }),

    computed: {
        getRubric() {
            if (this.rubric.id) {
                return Rubric.query().with(['criterias.criteria_ratings']).find(this.rubric.id);
            }

            return this.$store.getters[`${this.rubric.namespace}/getRubric`]({
                target: this.rubric.uuid,
            });
        },

        rubricTitle() {
            return this.getRubric.title;
        },

        criterias() {
            return this.getRubric.criterias;
        },

        totalPoints() {
            return this.criterias.reduce((total, item) => total + item.max_value, 0);
        },
    },

    created() {
        if (has(this.rubric, 'inline')) {
            this.displayRubric = true;
        }
    },

    methods: {
        toggleRubric() {
            if (has(this.rubric, 'inline')) {
                return;
            }

            this.displayRubric = !this.displayRubric;
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.display-rubric table td:first-child {
    @include from($tablet) {
        width: 15rem;
    }
}

:root[class*='app-dark'] .display-rubric {
    .table {
        background-color: var(--p-content-background);
        color: var(--p-text-color);

        td,
        th {
            border-color: var(--p-content-border-color);
            color: var(--p-text-color);
        }

        &.is-striped tbody tr:nth-child(even) {
            background-color: var(--p-surface-800);
        }

        &.is-hoverable tbody tr:hover {
            background-color: var(--p-surface-700);
        }
    }
}
</style>
